import React from 'react';
import Image from '../../../img/MainWebsite/GolfPage.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function ForGolf() {

  let navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent  whiteFont'}>
        <div className={'column'}>
          <h3 className={'left green'}>A Better Digital Experience for Golf Courses  </h3>
          <h5 className={'left'}> Vizo Menu gives golf courses a simple way to improve guest convenience, promote offerings, support pace of play, and create
            sponsor-driven revenue — without apps, downloads, hardware, POS integration, or investment.  </h5>
          <h5 className={'left'}> Designed specifically for golf courses, Vizo Menu provides a course-branded digital menu experience that golfers can access from
            their own phones or tablets.  </h5>

          <h3 className={'left green'}>Built for the Golf Experience  </h3>
          <h5 className={'left'}> Vizo Menu helps golf courses present:  </h5>
          <ul className={"two-columns"}>
            <li className={'green left'}><h5> Food and beverage menus  </h5></li>
            <li className={'green left'}><h5> Beverage cart offerings   </h5></li>
            <li className={'green left'}><h5> Pro shop merchandise  </h5></li>
            <li className={'green left'}><h5>  Golf instruction and services  </h5></li>
            <li className={'green left'}><h5> Tournaments, leagues, and events  </h5></li>
            <li className={'green left'}><h5>  Weddings and private events  </h5></li>
            <li className={'green left'}><h5>Promotions and featured items   </h5></li>
            <li className={'green left'}><h5>  Local sponsor placements </h5></li>
          </ul>
          <h5 className={'left'}> Golfers can browse offerings before they arrive, while they are on the course, at the turn, in the clubhouse, or in the pro shop.  </h5>

          <h3 className={'left green'}>More Convenience. Less Friction.  </h3>
          <h5 className={'left'}> Vizo Menu helps reduce delays and improve communication by giving golfers easier access to the information they need.  </h5>
          <h5 className={'left'}> Golfers can:  </h5>
          <ul className={"two-columns"}>
            <li className={'green left'}><h5> Alert the cart attendant when on-course service is needed   </h5></li>
            <li className={'green left'}><h5> Place advance orders before the turn   </h5></li>
            <li className={'green left'}><h5> View food and beverage options from their own device  </h5></li>
          </ul>
          <h5 className={'left'}> This helps create a smoother guest experience, helps protect pace of play by reducing unnecessary delays, and supports staff during
            busy periods.  </h5>

          <h3 className={'left green'}>Sponsor Revenue Without Advertising Clutter  </h3>
          <h5 className={'left'}> Vizo Menu’s sponsor-driven model allows golf courses to generate revenue through sponsor placements, with the flexibility to add
            sponsors as opportunities grow.  </h5>
          <h5 className={'left'}> Sponsor placements are organized in a clean, professional way that supports revenue without overwhelming the golfer experience.  </h5>
          <h5 className={'left'}> Sponsors receive affordable digital exposure through a golf-course-branded experience, reaching an engaged local audience in a
            highly targeted environment.  </h5>

          <h3 className={'left green'}>Course-Branded. Vizo Menu Behind the Scenes.  </h3>
          <h5 className={'left'}> The golfer experience is branded for the golf course, not Vizo Menu.  </h5>
          <h5 className={'left'}> Your course remains front and center. Your offerings, your style, your brand.  </h5>
          <h5 className={'left'}> Vizo Menu simply powers the digital experience behind the scenes.  </h5>

          <h3 className={'left green'}>No App. No Hardware. No POS Integration.  </h3>
          <h5 className={'left'}> Vizo Menu is designed to be simple to evaluate and easy to operate.  </h5>
          <h5 className={'left'}> There is:  </h5>
          <ul className={"two-columns"}>

            <li className={'green left'}><h5>  No app to download  </h5></li>
            <li className={'green left'}><h5> No hardware required    </h5></li>
            <li className={'green left'}><h5>  No formal staff training required  </h5></li>
            <li className={'green left'}><h5> No POS integration required    </h5></li>
            <li className={'green left'}><h5>  No setup fee    </h5></li>
            <li className={'green left'}><h5> No upfront investment  </h5></li>
            <li className={'green left'}><h5>No complicated process  </h5></li>
          </ul>
          <h5 className={'left'}> Vizo Menu fits into your existing operation without disrupting staff, service flow, or the systems you already use.  </h5>

          <h3 className={'left green'}>Proof Before Commitment  </h3>
          <h5 className={'left'}> Golf courses can evaluate Vizo Menu for 30 days before making a long-term commitment. There is no obligation and no credit card 
required to see whether Vizo Menu provides value to your operation.  </h5>
          <h5 className={'left'}> This gives your team the opportunity to see how the platform presents your offerings, supports guest convenience, and creates sponsor 
revenue potential before moving forward.  </h5>

          <h3 className={'left green'}> A Simple Enhancement With Real Value</h3>
          <h5 className={'left'}> Vizo Menu supplements your existing menus, service model, and operations — without disrupting staff, printed materials, POS 
systems, or the personal service golfers expect.  </h5>
          <h5 className={'left'}>It gives golf courses a cleaner, smarter way to present offerings, support on-course service, and generate new revenue — without 
adding unnecessary complexity.   </h5>

        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={' button-spacing chrome-background green-link'} onClick={() => { navigate("/Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO
          </button>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default ForGolf;